module.exports = __webpack_public_path__ + "a4864c5ea42facdc1d569129ddc8636f.pdf";